import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class iamAvatarCtrl implements IController {

  user: any;
  isLarge: any;
  onChange: Function;

  /* @ngInject */
  constructor() {
  }

  $onInit() {

  }

  onUpload(result) {
    var url = _.get(result, 'data.url');
    var userCopy = angular.copy(this.user);
    _.set(userCopy, 'pictureUrl', url);

    this.onChange({editedUser: userCopy})
  }

}

angular
  .module('bringoz.admin.iam')
  .component('iamAvatar', {
    bindings: {
      user: '<',
      isLarge: '<?',
      onChange: '&'
    },
    template: require('./iam-avatar.html').default,
    controller: iamAvatarCtrl
  });
